import { Component, Input } from '@angular/core';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { Router } from '@angular/router';
import { RoleType } from '@shared/enum/role-type';

@Component({
    selector: 'lemsar-header-container',
    templateUrl: './header.container.html',
})
export class HeaderContainer {
    @Input('transparent') public transparent: boolean = false;
    @Input('scrolled') public scrolled: boolean = false;

    public isLogin: boolean = false;
    public isAdmin: boolean = false;

    public constructor(private authStore: AuthStore, private router: Router) {
        if ('{}' !== JSON.stringify(this.authStore.user)) {
            this.isLogin = true;
            this.isAdmin = this.authStore.user.hasRole(RoleType.ADMIN);
        }
    }

    public logout(): void {
        this.router.navigateByUrl('/auth/logout');
    }
}



// WEBPACK FOOTER //
// ./apps/frontend/src/template/default/containers/header.container.ts